module.exports = __webpack_public_path__ + "img/modal-success-icon.3c54314a.svg";